import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import CollectionTooltip, { CollectionTooltipApi } from 'components/Collection/V2/Tooltip'
import AuthenticationConnect, {
  ConnectorProps as AuthenticationProps,
} from 'connectors/Authentication'
import { ActionItem } from './styles'

type Props = {
  artworkId: number
  handleOpenCreateCollectionsModal: () => void
  customAnimationStyle?: Record<string, any>
  tooltipPosition?: 'left' | 'right' | 'top' | 'bottom'
} & AuthenticationProps

export type AddToCollectionApi = {
  handleCreateCollectionCallback: (payload: any) => void
}

const AddToCollectionAction = forwardRef<AddToCollectionApi, React.PropsWithChildren<Props>>(
  (props, ref) => {
    const {
      artworkId,
      customAnimationStyle,
      handleOpenCreateCollectionsModal,
      tooltipPosition,
      children,
    } = props
    const collectionTooltipRef = useRef<CollectionTooltipApi>(null)

    const handleCreateCollectionCallback = (payload) => {
      collectionTooltipRef.current?.addArtworkToCollection(payload)
    }

    useImperativeHandle(ref, () => ({
      handleCreateCollectionCallback,
    }))

    return children ? (
      <CollectionTooltip
        artworkId={artworkId}
        handleOpenCreateCollectionsModal={handleOpenCreateCollectionsModal}
        ref={collectionTooltipRef}
        tooltipPosition={tooltipPosition}
        dataStyle='flex'
        customAnimationStyle={customAnimationStyle}
      >
        {children}
      </CollectionTooltip>
    ) : (
      <ActionItem data-action='collection' data-type='action' title='Add to Collection'>
        <CollectionTooltip
          artworkId={artworkId}
          handleOpenCreateCollectionsModal={handleOpenCreateCollectionsModal}
          ref={collectionTooltipRef}
        />
      </ActionItem>
    )
  }
)

export default AuthenticationConnect(AddToCollectionAction)
